import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../shared/services/api.service';
import { ColDef } from 'ag-grid-community';
import { DateService } from '../../../shared/services/date.service';

@Component({
  standalone: false,
  selector: 'app-beneficiary-transactions',
  templateUrl: './beneficiary-transactions.component.html',
  styleUrl: './beneficiary-transactions.component.scss'
})
export class BeneficiaryTransactionsComponent implements OnInit {

  customerId: string = '';
  beneficiaryId: string = '';
  transactions: any[] = [];
  gridApi: any;
  apiUrl: any;
  selectedFromDate: any;
  selectedToDate: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _api: ApiService,
    private _dateService: DateService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.customerId = params['customerId'];
      this.beneficiaryId = params['beneficiaryId'];
      if (this.customerId && this.beneficiaryId) {
        this.loadTransactions();
      }
    });
  }

  columnDefs: ColDef[] = [
    {
      headerName: 'Type',
      field: 'isRemittance',
      editable: false,
      filter: true,
      width: 120,
      valueFormatter: (params: any) => {
        return params.value ? 'Remittance' : 'Payment';
      },
      cellClass: (params: any) => {
        return params.value ? 'text-primary' : 'text-success';
      }
    },
    {
      headerName: 'Transaction Id',
      field: 'createdAt',
      editable: false,
      filter: true,
      width: 250,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    {
      headerName: 'Beneficiary Name',
      field: 'merchantName',
      editable: false,
      filter: true,
      width: 250,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    {
      headerName: 'Source Partner',
      field: 'sourceBankId.name',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Source Country',
      field: 'originationCountry.displayName',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Amount',
      field: 'conversions',
      editable: false,
      filter: true,
      valueFormatter: (params: any) => {
        try {
          const conversions = JSON.parse(params.value);
          return conversions.transactionAmount || '-';
        } catch (e) {
          return '-';
        }
      }
    },
   
    {
      headerName: 'Status',
      field: 'status',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Date',
      field: 'createdAt',
      editable: false,
      filter: false,
      valueFormatter: (params) =>
        this._dateService.getFormattedDateWithAMPM(params.value),
    },
  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  loadTransactions() {
    // TODO: Implement API call to get transactions for beneficiary
    // This is a placeholder - you need to replace with actual API endpoint
    const apiUrl = `/admin/transactions?customerId=${this.customerId}&beneficiaryId=${this.beneficiaryId}`;
    this._api.getData(apiUrl).subscribe((res: any) => {
      if (res && !res.error && res.data) {
        this.transactions = res.data;
        if (this.gridApi) {
          this.gridApi.refreshInfiniteCache();
        }
      }
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  getLatLongFromLocation(value: string): string {
    if (!value) return '-';
    try {
      const loc = JSON.parse(value);
      if (loc.coords) {
        const latitude = loc.coords.latitude;
        const longitude = loc.coords.longitude;
        return latitude + ', ' + longitude;
      }
      return '-';
    } catch (e) {
      return '-';
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;
        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        
        // TODO: Replace with actual API endpoint
        this.apiUrl = `/admin/transactions?customerId=${vm.customerId}&beneficiaryId=${vm.beneficiaryId}&_page=${request._page}&_limit=${request._limit}`;
        
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(function (k) {
          if (k && filterData[k]) {
            var filterValue = filterData[k].filter;
            if (k === 'amount') {
              vm.apiUrl += "&" + k + "_FULLMATCH=" + filterValue;
            } else {
              vm.apiUrl += "&" + k + "_like=" + filterValue;
            }
          }
        });

        if (vm.selectedFromDate && vm.selectedToDate) {
          const fromTimestamp = vm._dateService.dateToTimestamp(vm.selectedFromDate);
          const toTimestamp = vm._dateService.dateToTimestamp(vm.selectedToDate);
          if (!isNaN(fromTimestamp) && !isNaN(toTimestamp) && fromTimestamp > 0 && toTimestamp > 0) {
            vm.apiUrl += '&createdAtdatePickerRange=' + fromTimestamp + ',' + toTimestamp;
          }
        }

        vm._api.getData(this.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            const dt: any = [];
            Object.keys(res.data).map(r => {
              const obj = { type: r, value: res.data[r] };
              dt.push(obj);
            });
            res.data.value = dt;
            params.successCallback(res.data, res.count);
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  onDateSelected(result: { fromDate: any, toDate: any }) {
    const vm = this;
    vm.selectedFromDate = result.fromDate;
    vm.selectedToDate = result.toDate;
    
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  goBack() {
    this.router.navigate(['/app/customers/details'], { queryParams: { id: this.customerId } });
  }
}
